import { IGetSalesExpenseList, IMySalesExpenseListSearch, ISalesExpenseDetails, ISalesExpenseListSearch, IUpdateSalesExpenseStatus } from "../../../types/sales/salesExpenseInterface";
import { SalesExpenseActionTypes, SalesExpenseActions } from "../../actionTypes/sales/saleExpenseActionTypes";

export const createSalesExpense = (payload: FormData): SalesExpenseActionTypes => ({
  type: SalesExpenseActions.CREATE_SALES_EXPENSE,
  payload,
});

export const getSalesExpenseList = (payload: ISalesExpenseListSearch): SalesExpenseActionTypes => ({
  type: SalesExpenseActions.GET_SALES_EXPENSE_LIST,
  payload,
});

export const getMySalesExpenseList = (payload: IMySalesExpenseListSearch): SalesExpenseActionTypes => ({
  type: SalesExpenseActions.GET_MY_SALES_EXPENSE_LIST,
  payload,
});

export const setSalesExpenseList = (payload: Array<IGetSalesExpenseList>) : SalesExpenseActionTypes => ({
  type: SalesExpenseActions.SET_SALES_EXPENSE_LIST,
  payload
})

export const setMySalesExpenseList = (payload: Array<IGetSalesExpenseList>) : SalesExpenseActionTypes => ({
  type: SalesExpenseActions.SET_MY_SALES_EXPENSE_LIST,
  payload
})

export const setSalesExpenseListPageCount = (payload:number): SalesExpenseActionTypes => ({
  type: SalesExpenseActions.SET_SALES_EXPENSE_LIST_PAGE_COUNT,
  payload
})

export const setMySalesExpenseListPageCount = (payload: number): SalesExpenseActionTypes => ({
  type: SalesExpenseActions.SET_MY_SALES_EXPENSE_LIST_PAGE_COUNT,
  payload
})

export const getSalesExpenseDataById = (id: string): SalesExpenseActionTypes => ({
  type: SalesExpenseActions.GET_SALES_EXPENSE_DATA_BY_ID,
  payload: id
})

export const setSalesExpenseDataById = (payload: ISalesExpenseDetails) => ({
  type: SalesExpenseActions.SET_SALES_EXPENSE_DATA_BY_ID,
  payload
})

export const editSalesExpense = (payload: { id: string; data: FormData}) => ({
  type: SalesExpenseActions.EDIT_SALES_EXPENSE_DATA_BY_ID,
  payload,
});



export const updateSalesExpenseStatus = (payload: IUpdateSalesExpenseStatus) => ({
  type: SalesExpenseActions.UPDATE_SALES_EXPENSE_STATUS,
  payload,
});
